var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M825.717 1157.32C814.831 1168.21 801.907 1176.85 787.683 1182.75C773.458 1188.64 758.212 1191.67 742.815 1191.67C727.417 1191.67 712.171 1188.64 697.946 1182.75C683.722 1176.85 670.798 1168.21 659.912 1157.32L196.842 694.254C174.858 672.276 162.505 642.465 162.5 611.379V279.663C162.5 215.042 215.042 162.5 279.717 162.5H611.379C642.417 162.5 672.263 174.85 694.254 196.842L1157.32 659.912C1168.21 670.798 1176.85 683.722 1182.75 697.946C1188.64 712.171 1191.67 727.417 1191.67 742.815C1191.67 758.212 1188.64 773.458 1182.75 787.683C1176.85 801.907 1168.21 814.831 1157.32 825.717L825.717 1157.32Z",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.084 352.084L379.167 379.167",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsTag);
export default __webpack_public_path__ + "static/media/akar-icons_tag.3486dedec0a628013f839ce63fc971aa.svg";
export { ForwardRef as ReactComponent };